import $ from 'jquery';
import { getParam } from 'utilsES';
import * as request from 'requestES';
const getDeviceType = ext => {
  let userAgent = window.navigator.userAgent;
  let ua = userAgent.toLowerCase();
  let platform = {
    isAndroid: function () {
      return ua.indexOf('android') > -1;
    },
    isIOS: function () {
      let NPlatform = navigator.platform;
      return (
        ua.indexOf('iphone') > -1 ||
        /iPad|iPhone|iPod/gi.test(NPlatform) ||
        (NPlatform === 'MacIntel' &&
          navigator.maxTouchPoints > 1 &&
          !window.MSStream)
      );
    },
    isWinPhone: function () {
      return !!navigator.userAgent.match(/Windows Phone/i);
    },
    isIpad: function () {
      let NPlatform = navigator.platform;
      return (
        /iPad/gi.test(NPlatform) ||
        (NPlatform === 'MacIntel' &&
          navigator.maxTouchPoints > 1 &&
          !window.MSStream)
      );
    },
    isPhone: function () {
      return (
        this.isAndroid() || this.isIOS() || this.isWinPhone() || this.isIpad()
      );
    },
  };
  if (ext === 'ext10') {
    // 系统类型
    return platform.isAndroid() || platform.isWinPhone()
      ? 'android'
      : platform.isIOS() || platform.isIpad()
      ? 'ios'
      : 'pc';
  } else {
    return platform.isPhone() ? 'mobile' : 'pc';
  }
};

const getBranch = () => {
  return window.location.hostname.split('.')[1];
};

const getPlatform = () => {
  let branch = getBranch();
  let platformMap = {
    gm99: 'gm',
  };
  return platformMap[branch] || 'global';
};

const getRealLang = () => {
  let lang =
    window.navigator.language ||
    window.navigator.browserLanguage ||
    window.navigator.systemLanguage;
  if (lang.indexOf('-') > -1) {
    switch (lang.toLowerCase()) {
      case 'zh-cn':
        return 'zh';
      case 'zh-tw':
        return 'tw';
      default:
        return lang.toLowerCase().split('-')[0];
    }
  } else {
    return lang.toLowerCase();
  }
};

const sendData = url => {
  let img = document.createElement('img');
  img.src = url;
  document.getElementsByTagName('body')[0].appendChild(img);
  document.getElementsByTagName('body')[0].removeChild(img);
};

/**
 * 字段说明请wiki搜索“中转页GA打点数据来源升级说明”
 */
let dataCountHost =
  '//datain.octlib.com/api/v1/hw/common/event/collect?apikey=72e0e1c0-51e3-45ab-9b36-bf3b82143d9d&id=14';
let gameID =
  getParam('gameID') || getParam('gameId') || getParam('game_id') || '275';
let url =
  dataCountHost +
  '&gameID=' +
  gameID +
  '&ext1=' +
  (getParam('aid') || '') +
  '&ext2=' +
  encodeURIComponent(window.location.href) +
  '&ext3=' +
  gameID +
  '&ext4=' +
  (getParam('cid') || '') +
  '&ext5=' +
  (getParam('scid') || '') +
  '&ext6=' +
  (getParam('zone') || '') +
  '&ext7=' +
  new Date().getTime() +
  '&deviceCode=' +
  getDeviceType() +
  '&deviceFrom=' +
  getDeviceType('ext10') +
  '&ext10=' +
  getDeviceType('ext10') +
  '&ext11=' +
  getPlatform() +
  '&ext12=' +
  getBranch() +
  '&ext14=' +
  getRealLang() +
  '&ext15=' +
  (getParam('adid') || '') +
  '&ext16=' +
  (getParam('camid') || '') +
  '&ext17=' +
  (getParam('camname') || '') +
  '&ext18=' +
  (getParam('adsetid') || '') +
  '&ext19=' +
  (getParam('adsetname') || '') +
  '&ext20=' +
  (getParam('adname') || '');

export const commonUpload = (type, customValue = '') => {
  dataLayer.push({
    event: 'uploadStatistics',
    eventName: type,
    value: customValue,
    aid: window.aid || 'frxxyy',
    cid: window.cid,
    scid: window.scid,
    devicePlate: window.devicePlate,
  });
};
export const initReport = () => {
  let testIpUrl = '//gstore.endomainname.com/test_ip';

  request.ajax({ url: testIpUrl }).then(res => {
    if (
      parseInt(res.result, 10) === 1 &&
      Object.prototype.toString.call(res.data) == '[object Object]' &&
      Object.prototype.toString.call(res.data.info) == '[object Array]' &&
      res.data.info.length
    ) {
      url += '&ext13=' + res.data.info[0];
    }
    let sendDataTimer = setInterval(function () {
      if (localStorage && localStorage.getItem('activity_uuid')) {
        url += '&ext9=' + localStorage.getItem('activity_uuid');
        sendData(url);
        clearInterval(sendDataTimer);
      }
    }, 100);
  });

  // 安卓下载
  $("[data-gtm='gtm-download-android']").on('click', function () {
    var targetUrl = url + '&ext8=gtm-download-android';
    sendData(targetUrl);
  });
  // 苹果下载
  $("[data-gtm='gtm-download-apple']").on('click', function () {
    var targetUrl = url + '&ext8=gtm-download-apple';
    sendData(targetUrl);
  });
  // 点击预约按钮
  $("[data-gtm='gtm-yy-email']").on('click', function () {
    var targetUrl = url + '&ext8=gtm-yy-email';
    sendData(targetUrl);
  });
  // 提交预约按钮
  $("[data-gtm='gtm-yy-email-btn']").on('click', function () {
    var targetUrl = url + '&ext8=gtm-yy-email-btn';
    sendData(targetUrl);
  });

  // 非数据部上报，普通上报GA
  $('.j-collect').on('click', ({ currentTarget }) => {
    let eventName = currentTarget.dataset.collect;
    eventName && commonUpload('click_button', eventName);
  });
};

// 预约成功
export const sendSuccData = () => {
  let targetUrl = url + '&ext8=gtm-yy-email-success';
  sendData(targetUrl);
  dataLayer.push({
    event: "reserVationSuccess",
  });
  commonUpload('view_page', '预约成功');
};

// 时间上报
let timeCount = 0; // 页面计时
let pageTimer = null; // 计时器
export const setTimeCounter = () => {
  timeCount = 0;
  pageTimer = setInterval(() => {
    timeCount++;
  }, 3000);
};
export const uploadTimeCounter = name => {
  clearInterval(pageTimer);
  pageTimer = null;
  timeCount && commonUpload('view_page', name + '-' + ~~(timeCount * 3));
  setTimeCounter();
};

// 模拟器相关打点计时器，由于同时统计页面时长及游戏时长，故另起
let playGameTime = 0;
let gameTimer = null;
const startGameTime = () => {
  playGameTime = 0;
  gameTimer = setInterval(() => {
    playGameTime++;
  }, 3000);
};
const endGameTime = () => {
  clearInterval(gameTimer);
  gameTimer = null;
  playGameTime &&
    commonUpload('view_page', '修仙模拟器游玩-' + ~~(playGameTime * 3));
};
window._uploadPlayGame = () => {
  commonUpload('click_button', '开始修仙之旅');
  startGameTime();
};
window._uploadLifeRes = async () => {
  endGameTime();
};
